"use client";

import dynamic from "next/dynamic";

export const SpeechOrbWrapper = dynamic(() => import("./SpeechOrb").then(mod => mod.SpeechOrb));
